var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog"},[_c('ArticleNavigation',{attrs:{"blogInfo":_vm.blogInfo}}),_c('v-container',[(_vm.blogInfo.id && _vm.userInfo.id)?_c('ArticlesTable',{attrs:{"blogInfo":_vm.blogInfo,"userInfo":_vm.userInfo}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }